import http from '../http-common';

class RaiseComplaint {
  postRaiseComplaint(formdata) {
    return http.post('/raiseComplaint', formdata);
  }

  getTransactionDetails(propData) {
    const transData = {
      lang: propData.lang,
      mode: propData.mode,
      product: propData.productName,
      service: 'string',
      ticketId: propData.ticketId,
      token: token,
      transactionId: propData.txnId,
      trkrid: 'string'

    };
    return http.post('/transaction/getDetails', transData);
  }
}

export default new RaiseComplaint();
